import React from 'react';
import ReactDOM from 'react-dom';
import { X, AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Confirm', cancelText = 'Cancel', variant = 'danger' }) => {
  if (!isOpen) return null;

  const modalContent = (
    <div 
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" 
      style={{ zIndex: 10000 }} 
      onClick={onClose}
    >
      <div 
        className="bg-white dark:bg-dark-bg-secondary rounded-2xl max-w-md w-full shadow-2xl border dark:border-[#2e2e2d]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-6 border-b dark:border-[#2e2e2d]">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-3">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                variant === 'danger' 
                  ? 'bg-red-100 dark:bg-red-950/30' 
                  : 'bg-orange-100 dark:bg-orange-950/30'
              }`}>
                <AlertTriangle className={`w-6 h-6 ${
                  variant === 'danger' 
                    ? 'text-red-600 dark:text-red-400' 
                    : 'text-orange-600 dark:text-orange-400'
                }`} />
              </div>
              <div>
                <h2 className="text-xl font-bold text-text-dark dark:text-dark-text">
                  {title}
                </h2>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 dark:hover:bg-dark-bg-tertiary rounded-lg transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            {message}
          </p>
        </div>

        {/* Footer */}
        <div className="p-6 border-t dark:border-[#2e2e2d] flex items-center justify-end gap-3">
          <Button
            onClick={onClose}
            variant="outline"
            className="px-4 py-2"
          >
            {cancelText}
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`px-6 py-2 font-semibold ${
              variant === 'danger'
                ? 'bg-red-600 hover:bg-red-700 text-white'
                : 'bg-gradient-to-r from-orange-500 to-amber-500 text-white'
            }`}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ConfirmModal;
